export const TOKEN_SESSION_KEY = 'TOKEN';

export const LATITUDE = 'latitude';

export const LONGITUDE = 'longitude';

export const LANGUAGE = 'LANGUAGE';

export const CLIENT_NAME = {
	TWELVE_PC: '12% CLUB',
	TWELVE_PC_LDC: '12% CLUB ADD MONEY LDC',
	TP_CLUB_ADD_MONEY_LDC: 'TP_CLUB_ADD_MONEY_LDC',
	TP_CLUB_ADD_MONEY_LL: 'TP_CLUB_ADD_MONEY_LL',
	TP_CLUB_LOAN_REPAYMENT_LDC: 'TP_CLUB_LOAN_REPAYMENT_LDC',
	TP_CLUB_LOAN_REPAYMENT_LL: 'TP_CLUB_LOAN_REPAYMENT_LL',
	MERCHANT: 'merchant',
	POSTPE: 'POSTPE',
	UNITY: 'UNITY_BANK',
	BHARAT_SWIPE: 'BHARATSWIPE',
	DEPOSIT: 'DEPOSIT',
	TPCLUB_ADD_MONEY: 'TPCLUB_ADD_MONEY',
};

export const APPLICATION_NAME = {
	BHARATPE: 'BHARATPE',
	TPCLUB: 'TPCLUB',
	POSTPE: 'POSTPE',
	ZILLION: 'PAYBACK',
	UNITY_BANK: 'UNITY_BANK',
};

export const IOS_JUSPAY_APP_VERSIONS = {
	POSTPE: '113',
	TPCLUB: '106',
	BHARATPE: '254',
};

export const ANDROID_JUSPAY_APP_VERSIONS = {
	POSTPE: '125',
	TPCLUB: '120',
	BHARATPE: '325',
};
